import type DataSet from '@interfaces/DataSet';
import type {ReactElement} from 'react';

interface Props {
    dataSet?: DataSet;
    children(dataset: DataSet): ReactElement;
}

function prepareDataSet(dataSet: DataSet): DataSet {
    return Object.keys(dataSet).reduce((acc: DataSet, key) => {
        const transformedKey = `data-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`;
        acc[transformedKey] = (dataSet[key] ?? '').toString();
        return acc;
    }, {});
}

export default function DataSetProvider(props: Props): ReactElement {
    return props.children(prepareDataSet(props.dataSet ?? {}));
}
